import { render, staticRenderFns } from "./SelectorAccessoriesCard.vue?vue&type=template&id=a3e653d2&"
import script from "./SelectorAccessoriesCard.vue?vue&type=script&lang=js&"
export * from "./SelectorAccessoriesCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectorAccessoriesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3e653d2')) {
      api.createRecord('a3e653d2', component.options)
    } else {
      api.reload('a3e653d2', component.options)
    }
    module.hot.accept("./SelectorAccessoriesCard.vue?vue&type=template&id=a3e653d2&", function () {
      api.rerender('a3e653d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/SelectorAccessoriesCard.vue"
export default component.exports